import { Button, Grid } from '@material-ui/core';
import Context from 'context';
import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { Colors } from 'type';
import ColorPickerModal from './ColorPickerModal';
type SwatchProps = {
  color: string;
};
const Swatch = styled.span<SwatchProps>`
  height: 16px;
  width: 32px;
  margin-left: 8px;
  background-color: ${({ color }) => color};
  border: #ccc 1px solid;
`;

const ColorPicker = () => {
  const { colors, setColors } = useContext(Context);
  const [index, setIndex] = useState<number>(0);
  const [isAcitve, setActive] = useState<boolean>(false);

  const handleClick = (index: number) => {
    setActive(true);
    setIndex(index);
  };

  const colorsScheme = [
    {
      index: Colors.Background,
      name: 'พื้นหลัง',
    },
    {
      index: Colors.Primary,
      name: 'สี 1',
    },
    {
      index: Colors.Secondary,
      name: 'สี 2',
    },
    {
      index: Colors.Tertiary,
      name: 'สี 3',
    },
  ];
  return (
    <>
      <Grid item container>
        {colorsScheme.map(({ index, name }) => (
          <Grid item xs={3}>
            <Button
              fullWidth
              variant='outlined'
              onClick={() => handleClick(index)}
            >
              {name} <Swatch color={colors[index]} />
            </Button>
          </Grid>
        ))}
      </Grid>
      {isAcitve && <ColorPickerModal index={index} setActive={setActive} />}
    </>
  );
};

export default ColorPicker;
